import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "content" }
const _hoisted_2 = {
  key: 0,
  class: "form-empty"
}
const _hoisted_3 = { class: "infos" }
const _hoisted_4 = { class: "title" }
const _hoisted_5 = { class: "subtitle" }
const _hoisted_6 = { class: "action" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "actions" }

import { computed, ref, watchEffect, onMounted } from "vue";
import { useI18n } from "vue-i18n";
import { useRoute } from "vue-router";

import { toast } from "@/common/utils/toast";

import {
  analysisFormList,
  analysisFormCreate,
  analysisFormDelete,
} from "@/common/api/rest/analysis/form";

import type { AnalysisListType } from "@/common/types/analysis";
import type { FormType } from "@/common/types/form";

import { searchForm } from "@/components";
import {
  baseConfirm,
  baseModal,
  baseTooltip,
  svgIcon,
} from "@/common/components";


export default /*@__PURE__*/_defineComponent({
  __name: 'form',
  props: {
    data: {},
    width: { default: "100%" },
    isEdit: { type: Boolean, default: true }
  },
  emits: ["update-data"],
  setup(__props: any, { emit: __emit }) {

const { t } = useI18n();

const route = useRoute();

const emit = __emit;

const props = __props;

const selected = ref<any>(null);
const forms = ref<any[]>([]);

const showModalAdd = ref(false);
const showDelConfirm = ref(false);

const accountId = computed(() => route.params.id as string);

function fetchForm() {
  if (!props.data) return;

  analysisFormList(props.data.account_id, {
    analysis_id: props.data.analysis_id,
  })
    .then((response) => {
      const { success, data, message } = response;

      if (success) {
        forms.value = data.list;
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function add() {
  showModalAdd.value = true;
}

function addCancel() {
  showModalAdd.value = false;
}

function addSelect(data: FormType) {
  selected.value = data;
}

function addConfirm() {
  showModalAdd.value = false;

  analysisFormCreate(props.data.account_id, {
    evaluation_id: props.data.evaluation_id,
    analysis_id: props.data.analysis_id,
    form_id: selected.value.form_id,
  })
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("update-data");
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
}

function del(item: FormType) {
  selected.value = item;
  showDelConfirm.value = true;
}

function delCancel() {
  selected.value = null;
  showDelConfirm.value = false;
}

function delConfirm() {
  showDelConfirm.value = false;

  analysisFormDelete(props.data.account_id, selected.value.item_id)
    .then((response) => {
      const { success, message } = response;

      if (success) {
        emit("update-data");
        delCancel();
        toast({ message: message, type: "success" });
      } else {
        toast({ message: message, type: "error" });
      }
    })
    .catch(() => {
      toast({ message: t("error.default"), type: "error" });
    });
  delCancel();
}

watchEffect(() => {
  fetchForm();
});

onMounted(() => {
  fetchForm();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", {
    class: _normalizeClass(["analyse-tab", { width: __props.width }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      (forms.value.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_unref(t)("analysis.texts.empty_form")), 1))
        : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(forms.value, (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: "header"
            }, [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, _toDisplayString(item.code), 1),
                _createElementVNode("div", _hoisted_5, _toDisplayString(item.name), 1)
              ]),
              _createElementVNode("div", _hoisted_6, [
                _createVNode(_unref(baseTooltip), null, {
                  trigger: _withCtx(() => [
                    _createElementVNode("button", {
                      type: "button",
                      class: "btn btn-none btn-sm remove",
                      onClick: ($event: any) => (del(item))
                    }, [
                      _createVNode(_unref(svgIcon), {
                        icon: "trash",
                        size: "1.75rem"
                      })
                    ], 8, _hoisted_7)
                  ]),
                  tooltip: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref(t)("common.labels.delete")), 1)
                  ]),
                  _: 2
                }, 1024)
              ])
            ]))
          }), 128)),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("button", {
          class: "btn btn-md btn-primary",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (add()))
        }, _toDisplayString(_unref(t)("common.labels.add").toUpperCase()), 1)
      ])
    ]),
    _createVNode(_unref(baseModal), {
      show: showModalAdd.value,
      title: 
        _unref(t)('common.labels.add', {
          concat: _unref(t)('common.labels.form'),
        }).toUpperCase()
      ,
      "show-button-confirm": true,
      "button-confirm": _unref(t)('common.labels.add'),
      "button-close": _unref(t)('common.labels.cancel'),
      onClose: _cache[1] || (_cache[1] = ($event: any) => (addCancel())),
      onConfirm: _cache[2] || (_cache[2] = ($event: any) => (addConfirm()))
    }, {
      content: _withCtx(() => [
        _createVNode(_unref(searchForm), {
          width: "600px",
          "account-id": accountId.value,
          ids: forms.value.map((item) => item.form_id),
          onUpdateData: addSelect
        }, null, 8, ["account-id", "ids"])
      ]),
      _: 1
    }, 8, ["show", "title", "button-confirm", "button-close"]),
    _createVNode(_unref(baseConfirm), {
      show: showDelConfirm.value,
      "max-width": "400px",
      title: 
        _unref(t)('common.labels.remove', {
          concat: _unref(t)('common.labels.form'),
        }).toUpperCase()
      ,
      message: 
        _unref(t)('common.texts.remove_message', {
          concat: _unref(t)('common.labels.form'),
        })
      ,
      onCancel: delCancel,
      onConfirm: delConfirm
    }, null, 8, ["show", "title", "message"])
  ], 2))
}
}

})